export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-screen-2xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          当前最受瞩目的影视专题推荐
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {[
            {
              img: 'https://readdy.ai/api/search-image?query=interstellar%20space%20wormhole%20with%20stars%20and%20galaxy%2C%20cinematic%20sci-fi%20scene%2C%20dramatic%20golden%20and%20black%20tones%2C%20epic%20space%20aesthetic%2C%20film%20poster%20style%2C%20no%20text%20no%20people&width=800&height=500&seq=carousel-01-97&orientation=landscape',
              tag: '科幻经典', title: '《星际穿越》十周年纪念', subtitle: '诺兰科幻神作，跨越时空的父女情深',
            },
            {
              img: 'https://readdy.ai/api/search-image?query=ancient%20Chinese%20mythological%20epic%20battle%20scene%20with%20warriors%20and%20gods%2C%20dramatic%20cinematic%20lighting%2C%20warm%20golden%20and%20red%20tones%2C%20grand%20scale%20fantasy%20aesthetic%2C%20film%20poster%20style%2C%20no%20text&width=800&height=500&seq=carousel-02-97&orientation=landscape',
              tag: '热映推荐', title: '暑期档重磅：《封神第二部》', subtitle: '神话史诗续作，视觉奇观全面升级',
            },
            {
              img: 'https://readdy.ai/api/search-image?query=mysterious%20crime%20investigation%20scene%20with%20foggy%20cityscape%2C%20suspenseful%20detective%20drama%2C%20dark%20cinematic%20lighting%20with%20warm%20amber%20highlights%2C%20noir%20aesthetic%2C%20film%20poster%20style%2C%20no%20text%20no%20people&width=800&height=500&seq=carousel-03-97&orientation=landscape',
              tag: '新剧速递', title: '国产悬疑剧天花板来了', subtitle: '《三大队》导演新作，迷雾重重层层反转',
            },
            {
              img: 'https://readdy.ai/api/search-image?query=fantasy%20anime%20landscape%20with%20elf%20and%20magical%20forest%2C%20warm%20golden%20sunlight%20through%20trees%2C%20healing%20adventure%20atmosphere%2C%20Japanese%20anime%20film%20style%20with%20soft%20colors%2C%20no%20text&width=800&height=500&seq=carousel-04-97&orientation=landscape',
              tag: '动画精选', title: '日漫神作《葬送的芙莉莲》', subtitle: '治愈系冒险史诗，豆瓣9.4分口碑炸裂',
            },
            {
              img: 'https://readdy.ai/api/search-image?query=dark%20Korean%20drama%20scene%20with%20elegant%20woman%20silhouette%2C%20revenge%20thriller%20atmosphere%2C%20luxurious%20interior%20with%20dramatic%20shadow%20lighting%2C%20warm%20golden%20and%20deep%20red%20tones%2C%20film%20poster%20style%2C%20no%20text%20no%20identifiable%20faces&width=800&height=500&seq=carousel-05-97&orientation=landscape',
              tag: '全集放送', title: '韩剧《黑暗荣耀》全集上线', subtitle: '宋慧乔复仇爽剧，年度现象级话题之作',
            },
            {
              img: 'https://readdy.ai/api/search-image?query=vintage%20Hong%20Kong%20street%20scene%20with%20neon%20signs%20and%20rain%2C%20nostalgic%20Wong%20Kar-wai%20film%20aesthetic%2C%20cinematic%20warm%20green%20and%20golden%20tones%2C%20romantic%20atmosphere%2C%20film%20poster%20style%2C%20no%20text%20no%20people&width=800&height=500&seq=carousel-06-97&orientation=landscape',
              tag: '经典重温', title: '蓝光修复：王家卫电影全集', subtitle: '花样年华、重庆森林等经典4K重制',
            },
          ].map((item, i) => (
            <div key={i} className="group relative rounded-lg overflow-hidden cursor-pointer aspect-[8/5]">
              <img
                src={item.img}
                alt={item.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute top-4 left-4">
                <span className="px-3 py-1 text-xs font-medium text-background-50 bg-accent-500/90 rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="text-base font-bold text-background-50 mb-1">{item.title}</h3>
                <p className="text-xs text-background-200/80">{item.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}